import type { LucideIcon } from "lucide-react";

interface Props {
  label: string;
  value: string | number;
  detail?: string;
  icon: LucideIcon;
  tone?: "blue" | "green" | "purple" | "amber";
  trend?: string;
}

export function MetricCard({
  label,
  value,
  detail,
  icon: Icon,
  tone = "blue",
  trend,
}: Props) {
  return (
    <article className={`metric-card metric-card--${tone}`}>
      <span className="metric-card__icon">
        <Icon aria-hidden="true" />
      </span>
      <div>
        <p>{label}</p>
        <strong>{value}</strong>
        {detail && <small>{detail}</small>}
        {trend && <span className="metric-card__trend">{trend}</span>}
      </div>
    </article>
  );
}
